//import CookieManager from '@react-native-cookies/cookies';
import { GetUserResponse,  User, Session } from '../AuthDataTypes';
import { getUser } from './auth';

export const checkForSessionCookie = async (session: Session | null, login: Function, logout: Function) => {
  
    try {
      /*
      const cookie = await CookieManager.get(
        'https://staging.boyens-api.de/api',
        true
      );
      //console.log(JSON.stringify(cookie, null, 2));
      const feTypoUserCookie = cookie?.fe_typo_user;

      if (feTypoUserCookie && feTypoUserCookie.value) {
        //console.log(JSON.stringify(feTypoUserCookie, null, 2));

        const response: GetUserResponse = await getUser(cookie.fe_typo_user.value);
        //console.log("getUser response:", response);
        if (response && response.uid) {
          const loginData: User = {
            id: response.uid,
            name: response.username,
            permissions: ['user'],
            subscriptions: null,
            favouriteEdition: 'DLZ'
          };

          const newSession: Session = {
            token: cookie.fe_typo_user.value,
            editionFilter: null,
            dateFilter: '',
          };

          if (session) {
            session.token = cookie.fe_typo_user.value;
          };

          login(loginData, session ? session : newSession);
        } else {
          console.log('No Response getUser');
          logout()
        }

      } else {
        console.log('No Cookie Found', 'Please log in.');
      }
      */

      const response: GetUserResponse = await getUser('token324324234234');
        //console.log("getUser response:", response);
        if (response && response.uid) {
          const loginData: User = {
            id: response.uid,
            name: response.username,
            permissions: ['user'],
            subscriptions: null,
            favouriteEdition: 'DLZ'
          };

          const newSession: Session = {
            token: 'token324324234234',
            editionFilter: null,
            dateFilter: '',
          };

          if (session) {
            session.token = 'token324324234234';
          };

          login(loginData, session ? session : newSession);
        } 
        else {
          console.warn('No Response getUser');
          logout()
        }
    } catch (error) {
      console.error("Error checking for session cookie:", error);
    }
};
